import { Reducer } from 'redux';
import { GET_CHANGE_REQUESET_REASON_TYPES } from '@/app/common/reference-data/reference-data-actions';
import { IChangeRequestReasonTypesState } from '@/interfaces/change-request-reason-types-state';

const initialState = {
  reasonTypes: []
};

export const changeRequestReasonTypesReducer: Reducer<IChangeRequestReasonTypesState> = (state: IChangeRequestReasonTypesState = initialState, action) => {
  switch (action.type) {
    case GET_CHANGE_REQUESET_REASON_TYPES.SUCCESS:
      return { ...state, reasonTypes: action.payload.reasonTypes };

    default:
      return state;
  }
};
